import type { DocAssetType } from "@/lib/document/assetTypes";

export const DOC_ASSET_TYPE_OPTIONS: { id: DocAssetType; label: string }[] = [
  { id: "logo", label: "Logo" },
  { id: "signature", label: "Signature" },
  { id: "photo", label: "Photo" },
  { id: "icon", label: "Icon" },
  { id: "background", label: "Background" },
  { id: "other", label: "Other" },
];

export const DOC_ASSET_TYPE_LABEL: Record<DocAssetType, string> = {
  logo: "Logo",
  signature: "Signature",
  photo: "Photo",
  icon: "Icon",
  background: "Background",
  other: "Other",
};

export const DOC_ASSET_ACCEPT = "image/jpeg,image/png,image/webp,image/gif";
